import React, { useState, useEffect } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { Button, Alert } from "antd";
import { putForm } from "./FormPart";
import { getStoredItem } from "./client";
const StripeCheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (!stripe) return;
    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );
    if (clientSecret) {
      stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
        switch (paymentIntent.status) {
          case "succeeded":
            const data = {
              uid: getStoredItem("uid"),
              token: getStoredItem("token"),
              application_type: getStoredItem("applicationType"),
              form_id: "4_1",
              form_data: "",
            };
            putForm(data, props.props);
            break;
          case "processing":
            setErrorMessage(
              "Your payment is processing. We'll update you via email when the payment is completed."
            );
            break;
          case "requires_payment_method":
            setErrorMessage(
              "Payment failed. Please try another payment method."
            );
            break;
          default:
            setErrorMessage(
              "Could not process payment, please try again later."
            );
        }
      });
    }
  }, [stripe, props.props]);
  const handleSubmit = async (event) => {
    props.props.setSpin(true);
    event.preventDefault();
    const paymentStatusUrl = window.location + ""; /*+'payment-status'*/
    if (!stripe || !elements) {
      return;
    }
    const error = await stripe
      .confirmPayment({
        elements,
        confirmParams: {
          return_url: paymentStatusUrl,
        },
      })
      .then(() => {
        setErrorMessage("Could not process payment, please try again later.");
      })
      .finally((func) => {
        props.props.setSpin(false);
      });

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      setErrorMessage(error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  return (
    <div className="payment-page">
      <h1 style={{ color: "#431a75" }}>Payment Summary</h1>
      <p>Application Fee: ${props.props.formData.application_fee}</p>
      <hr />
      <div>
        <h3 style={{ color: "#431a75" }}>Payment via Zelle</h3>
        <p>Email: {props.props.formData.zelle_email}</p>
        <p>Registered as: {props.props.formData.zelle_alias}</p>
        <p>Send a copy of the receipt to {props.props.formData.zelle_email}</p>
        <h3>
          <b>Transfer Amount: ${props.props.formData.application_fee}</b>
        </h3>
      </div>
      <hr />
      <form onSubmit={handleSubmit}>
        <h3 style={{ color: "#431a75" }}>Pay via Credit/Debit Card</h3>

        <PaymentElement
          options={{
            layout: {
              type: "accordion",
              defaultCollapsed: false,
              radios: true,
              spacedAccordionItems: true,
            },
          }}
        />
        <p>Transaction Fee: ${props.props.formData.transaction_fee}</p>
        <h3>
          <b>Total Amount Due: ${props.props.formData.payment_now}</b>
        </h3>
        {errorMessage && (
          <Alert
            message={errorMessage}
            style={{ "text-align": "center" }}
            description=""
            showIcon
            type="error"
          />
        )}
        <Button
          block
          type="primary"
          htmlType="submit"
          size="large"
          disabled={!stripe}
        >
          Pay ${props.props.formData.payment_now}
        </Button>
      </form>
    </div>
  );
};

export default StripeCheckoutForm;
